import { Navigate } from 'react-router-dom';
import { useLocalStorage } from '@grcs/hook/useLocalStorage';
import { UserRole } from '@grcs/types/UserRole';

export type ProtectedRouteProps = {
  access: UserRole;
  children: any;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  access,
  children,
}) => {
  const [{ isLogin, role }] = useLocalStorage('user', {});
  if (!isLogin || role !== access) {
    // user is not authenticated
    console.log('not authenticated');
    return <Navigate to="/" replace />;
  }
  return children;
};
